<!--
 * @Author: wbf
 * @LastEditTime: 2024-10-14 10:48:32
 * @Description: 绑定手机
-->
<template>
  <div class="box">
    <NavBar
      :title="$t(`webapp.menus.${$route.meta.field}`)"
      :left-arrow="$route.meta.isShowArrow"
      @click-left="$router.back()"
      nav-bar-icon-color="#000"
      class="navbarSelf"
    ></NavBar>

    <Form @submit="onSubmit" class="vertical_self_form">
      <Field
        v-model="form.account"
        name="account"
        :label="$t('base.mobile.label')"
        :placeholder="$t('base.mobile.placeholder')"
        :show-error-message="false"
        :scroll-to-error="true"
        :rules="[{ required: true, validator: handlePass }]"
      >
        <template #button v-if="type == 'forget'">
          <div style="color: #2197e7">{{ beforePhone | handlePhone }}</div>
        </template>
      </Field>
      <Field
        v-model="form.captcha"
        name="captcha"
        :placeholder="$t('base.captcha.placeholder')"
        :show-error-message="false"
        :scroll-to-error="true"
        :rules="[{ required: true }]"
      >
        <template #button>
          <div v-if="count == 60" class="btn" @click="handleSendCode">
            {{ $t("base.btn.get_code") }}
          </div>
          <div v-else class="btn">{{ count }}s</div>
        </template>
      </Field>

      <div style="margin-top: 30px">
        <Button round block type="info" native-type="submit">
          {{
            type == "activate" || type == "forget"
              ? $t("base.btn.next_step")
              : $t("base.btn.bind")
          }}
        </Button>
      </div>
    </Form>
  </div>
</template>

<script>
import { Field, Icon, Form, Button, Toast, NavBar } from "vant";
import { toast } from "@/utils/toast";
import { commonAPI } from "@/apis";
import { delay } from "@/utils";
import { mapGetters } from "vuex";

export default {
  name: "BindPhone",
  components: { Field, Icon, Form, Button, Toast, NavBar },
  data() {
    return {
      form: {},
      type: "",
      beforePhone: "",
      count: 60,
      userInfo: {},
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  filters: {
    handlePhone(v) {
      console.log(v);
      if (v) {
        const tel = String(v);
        var str = tel.replace(tel.substring(3, 7), "****");
        return str;
      }
    },
  },
  created() {
    // 账号激活带过来的数据
    this.type = this.$route.query.type || "";
    if (this.type == "forget") {
      this.userInfo = JSON.parse(localStorage.getItem("FORGET_INFO")) || {};
    } else if (this.type == "activate") {
      this.userInfo = JSON.parse(localStorage.getItem("ACTIVATE_INFO")) || {};
    } else {
      this.userInfo = JSON.parse(sessionStorage.getItem("user")) || {};
      if (this.userInfo.mobile) {
        this.form = { ...this.form, account: this.userInfo.mobile };
      }
    }
    console.log(this.type, this.userInfo, this.user);
  },
  methods: {
    // 校验手机号
    handlePass(value) {
      let reg1 = new RegExp(/^1[3456789]\d{9}$/); // 手机号
      if (!reg1.test(value)) {
        return false;
      }
      return true;
    },
    // 获取验证码方法
    async getCodeApi(params) {
      const { code, message } = await commonAPI.getAction(
        "/send/msg/sendCaptcha",
        params
      );
      if (code == 0) {
        toast(message);
        // 开启倒计时
        const timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--;
          } else {
            this.count = 60;
            clearInterval(timer);
          }
        }, 1000);
      } else {
        toast(message);
      }
    },
    // 获取验证码
    handleSendCode() {
      if (!this.form.account) {
        return toast(this.$t("base.mobile.placeholder"));
      }
      let params = {
        noticeClassify: "2",
        businessClassify:
          this.type == "activate"
            ? "account_active"
            : this.type == "forget"
            ? "retrieve_password"
            : "change_phone_email",
        account: this.form.account,
      };
      this.getCodeApi(params);
    },
    async nextCodeApi(params) {
      let forgetUsername = "";
      try {
        forgetUsername =
          this.$route.query.userName ||
          this.$route.query.username ||
          (JSON.parse(localStorage.getItem("FORGET_INFO") || "{}").username) ||
          "";
      } catch (e) {
        forgetUsername = this.$route.query.userName || this.$route.query.username || "";
      }
      const { code, message, data } = await commonAPI.getAction(
        "/user/active/checkCaptcha",
        {
          ...params,
          userAcount: forgetUsername,
          username: forgetUsername,
        }
      );
      if (code == 0) {
        toast(message);
        this.$router.push({
          path: "/mnewPassword",
          query: {
            type: this.type,
            userName: forgetUsername || this.$route.query.userName,
            name: this.$route.query.name,
            businessClassify: params.businessClassify,
            captcha: params.captcha,
            noticeClassify: params.noticeClassify,
            account: params.account,
            resetToken: data,
          }, //表示类型是账号激活或者是忘记密码
        });
      } else {
        toast(message);
      }
    },
    async onSubmit(values) {
      console.log("submit", this.form);

      if (this.type == "activate" || this.type == "forget") {
        //账号激活和忘记密码的绑定手机号
        let params = {
          noticeClassify: "2",
          businessClassify:
            this.type == "activate"
              ? "account_active"
              : this.type == "forget"
              ? "retrieve_password"
              : "",
          ...this.form,
        };

        this.nextCodeApi(params);
      } else {
        console.log(this.user.username);
        // 首页中的绑定手机号
        const { code, message } = await commonAPI.postAction(
          `/users/bindPhone/${this.user.username}`,
          this.form
        );
        if (code == 0) {
          toast(message);
          await delay(1000);

          this.$router.push({ path: "/mAuthServer" });
        } else {
          toast(message);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";

.box {
  height: 100vh;
  .btn {
    border-radius: 4px;
    color: #2197e7;
    border: 1px solid #2197e7;
    font-size: 14px;
    line-height: 14px;
    padding: 7px 15px;
  }
}
</style>
